import * as React from 'react';

import appUrls from 'base/app/urls';
import { Container, Wrapper, TopBar } from 'common/components';
import {
  ContentProvider,
  ContentList,
  FiltersForm,
  Sort,
  StatusFilter,
  SearchInput,
} from 'templates/content';

import ScenariosContentRow from '../components/ScenariosContentRow';
import { useScenariosList } from '../queries';
import ScenarioDetails from './ScenarioDetails';
import { DetailsSwitch } from 'templates/details';

const fields = {
  search: 'search',
  filter: 'filter',
  sort: 'sort',
};

const ScenariosList = () => {
  const { data, isError } = useScenariosList();
  const path = {
    details: appUrls.SCENARIOS.DETAILS,
    list: appUrls.SCENARIOS.LIST,
  };
  const context = {
    data: data?.values,
    path,
  };

  return (
    <Container>
      <ContentProvider {...context}>
        <TopBar title="Scenarios">
          <FiltersForm
            sort={['title', fields.sort]}
            search={['title', fields.search]}
            filter={['status', fields.filter]}
          >
            <Wrapper margin={[0, 0.5]}>
              <SearchInput name={fields.search} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <StatusFilter name={fields.filter} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <Sort name={fields.sort} />
            </Wrapper>
          </FiltersForm>
        </TopBar>
        <ContentList isError={isError}>{ScenariosContentRow}</ContentList>
        <DetailsSwitch>
          <ScenarioDetails />
        </DetailsSwitch>
      </ContentProvider>
    </Container>
  );
};

export default ScenariosList;
